import { useMutation, useQueryClient } from '@tanstack/react-query'
import { confirmSignUp, autoSignIn } from 'aws-amplify/auth'

import { queries } from 'src/lib/query-keys'
import { sendEvent } from 'src/shared/api/events/send-event'

export const useConfirmSignUp = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ email, code }: { email: string; code: string }) => {
      const result = await confirmSignUp({
        username: email,
        confirmationCode: code,
      })

      try {
        const { nextStep } = await autoSignIn()
        if (nextStep?.signInStep === 'DONE') {
          await queryClient.invalidateQueries({ queryKey: queries.auth._def })
          sendEvent({ eventType: 'auth_confirm_signup_success', info: { email } })
        }
      } catch {
        // Auto sign-in failed, user needs to sign in manually
        sendEvent({ eventType: 'auth_confirm_signup_auto_signin_failed', info: { email } })
      }

      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      sendEvent({
        eventType: 'auth_confirm_signup_error',
        info: { error: errorName },
      })
    },
  })
}
